import { minLength, required } from 'vuelidate/lib/validators'

export const passwordValidators = {
    required,
  //TODO disabled for development only
    // minLength: minLength(8),
    // containsUppercase: (value) => /[A-Z]/.test(value),
    // containsNumber: (value) => /[0-9]/.test(value),
    // containsSpecial: (value) => /[#?!@$%^&*-]/.test(value),
}
